@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title }}"
		[(visible)]="display"
		[transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
		[modal]="true"
		[draggable]="false"
		[resizable]="false"
		[closeOnEscape]="false"
		(onHide)="onHide($event)"
		[style]="{ width: '90vw', height: '90vh' }"
	>
		<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region DRIVER INFO CARD SETTINGS MAIN CONTAINER -->
		<p-panel header="{{ 'drivers.form.driverData' | translate }}" class="w-100 driver-data-panel">
		<div class="row mt4 align-items-center">
			<div class="col-4">
				<!-- <img id="vehicle-data-settings-image" [src]="imageUrl" i18n-alt alt="{{'general.driverImage' | translate}}" class="img-fluid rounded-circle"
        style="max-width: 75%;"> -->
				<img
					id="vehicle-data-settings-image"
					src="{{ userEncodedImage }}"
					i18n-alt alt="{{'general.driverImage' | translate}}"
					class="custom-user-profile-image mx-auto d-block p-0 img-fluid rounded-circle"
				/>
				<div id="outer-icon-holder" class="d-flex mx-auto align-items-center justify-content-center">
					<div
						id="inner-icon-holder"
						class="d-flex align-items-center justify-content-center"
						(click)="uploadImageInput.click()"
					>
						<img src="assets/icons/camera-plus.png" class="custom-user-profile-icon" />
						<input
							[disabled]="!canEdit"
							#uploadImageInput
							[hidden]="true"
							type="file"
							accept=".jpg, .png"
							(change)="imageChange($event)"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 mt-3">
				<label for="fine-name" class="form-label custom-label fw-bold small mb-2 d-block" i18n>
					<strong>{{ 'drivers.employee' | translate }} (*)</strong>
				</label>
				<p-select
					[options]="employeeList"
					[(ngModel)]="entity.employee"
					placeholder="{{ 'general.select' | translate }} {{ 'drivers.employee' | translate }}"
					dataKey="id"
					optionLabel="fullName"
					[style]="{ width: '100%' }"
					appendTo="body"
					[filter]="true"
					(onChange)="onChangeEmployee($event)"
					(onFilter)="onFilterEmployee($event)"
					[disabled]="!isNew"
				>
					<ng-template let-employee pTemplate="item">
						<div class="flex align-items-center gap-2">
							<div>
								({{ employee.code }}) {{ employee.user.surname1 }} {{ employee.user.surname2 }}
								{{ employee.user.name }}
							</div>
						</div>
					</ng-template>
				</p-select>
			</div>
			<div class="col-sm-4 mt-3">
				<!-- CODE -->
				<label for="vehicle-data-settings-field2" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.code' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field2"
					[ngModel]="entity.employee?.code"
					class="form-control custom-input"
				/>
			</div>
		</div>
		<div class="row mt4 mb-4">
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field3" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.name' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field3"
					[ngModel]="entity.employee?.user.name"
					class="form-control custom-input"
				/>
			</div>
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field4" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.surname' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field4"
					[ngModel]="entity.employee?.user.surname1"
					class="form-control custom-input"
				/>
			</div>
			<div class="col-sm-3 mt-3">
				<!-- SECOND SURNAME -->
				<label for="vehicle-data-settings-field4" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.secondSurname' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field4"
					[ngModel]="entity.employee?.user.surname2"
					class="form-control custom-input"
				/>
			</div>
			<div class="col-sm-3 mt-3">
				<!-- NIF -->
				<label for="vehicle-data-settings-field5" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.nif' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field5"
					[ngModel]="entity.employee?.nif"
					class="form-control custom-input"
				/>
			</div>
		</div>
		<div class="row mt4 mb-4">
			<div class="col-sm-3 mt-3">
				<!-- NIF'S EXPIRATION DATE -->
				<label for="vehicle-data-settings-field6" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.expirationDateNif' | translate }}
				</label>
				<input
					type="date"
					id="vehicle-data-settings-field6"
					[ngModel]="entity.employee?.nifExpirationDate"
					(change)="changeNifExpirationDate($event)"
					class="form-control custom-input"
				/>
			</div>
			<div class="col-sm-3 mt-3">
				<!-- NIF'S EXPEDITION DATE -->
				<label for="vehicle-data-settings-field6" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.expeditionDateNif' | translate }}
				</label>
				<input
					type="date"
					id="vehicle-data-settings-field6"
					[ngModel]="entity.employee?.nifExpeditionDate"
					(change)="changeNifExpeditionDate($event)"
					class="form-control custom-input"
				/>
			</div>
			<!-- BIRTH DATE -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field7" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.birthDate' | translate }}
				</label>
				<input
					[disabled]="true"
					type="date"
					id="vehicle-data-settings-field7"
					[ngModel]="entity.employee?.user.birthDate"
					class="form-control custom-input"
				/>
			</div>
			<!-- ADDRESS -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field1" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.address' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field1"
					[ngModel]="entity.employee?.user.address"
					pTooltip="{{ entity.employee?.user.address }}"
					class="form-control custom-input"
				/>
			</div>
		</div>
		<div class="row mt-4 mb-4">
			<!-- POSTAL CODE -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field8" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.postalCode' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field9"
					[ngModel]="entity.employee?.user.cp"
					class="form-control custom-input"
				/>
			</div>
			<!-- POPULATION -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field8" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.population' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field9"
					[ngModel]="entity.employee?.user.population"
					class="form-control custom-input"
				/>
			</div>
			<!-- PHONE NUMBER -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field1" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.phoneNumber' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field1"
					[ngModel]="entity.employee?.user.phoneNumber"
					class="form-control custom-input"
				/>
			</div>
			<!-- EXTENSION -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field8" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.extension' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field9"
					[ngModel]="entity.employee?.extension"
					class="form-control custom-input"
				/>
			</div>
		</div>
		<div class="row mt-4 mb-4">
			<!-- MOBILE NUMBER -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field8" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.movil' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field9"
					[ngModel]="entity.employee?.professionalPhoneNumber"
					class="form-control custom-input"
				/>
			</div>
			<!-- RPV -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field8" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.rpv' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="vehicle-data-settings-field9"
					[ngModel]="entity.employee?.rpv"
					class="form-control custom-input"
				/>
			</div>
			<!-- COMPANY EMAIL -->
			<div class="col-sm-3 mt-3">
				<label for="vehicle-data-settings-field8" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.companyEmail' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="driver-data-field5"
					[ngModel]="entity.employee?.professionalEmail"
					class="form-control custom-input"
				/>
			</div>
			<!-- PERSONAL EMAIL -->
			<div class="col-sm-3 mt-3">
				<label for="driver-data-field5" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					{{ 'drivers.form.personalEmail' | translate }}
				</label>
				<input
					[disabled]="true"
					type="text"
					id="driver-data-field5"
					[ngModel]="entity.employee?.email"
					class="form-control custom-input"
				/>
			</div>
		</div>
		</p-panel>
		<!-- #endregion -->
		<div class="container-fluid p-0 custom-panel driver-tabs-panel">
			<!-- #region ROW 1: VEHICLE INFO CARD NAV TABS -->
			<div class="row m-0 mt-4">
				<ul class="nav nav-tabs custom-nav-tabs">
					<li class="nav-item">
						<a
							href="#driver-data1"
							class="nav-link active p-0 custom-title custom-tab-title first-nav-tab"
							data-bs-toggle="tab"
						>
							<div class="d-flex align-items-center justify-content-center h-100">
								{{ 'drivers.form.company' | translate }}
							</div>
						</a>
					</li>

					@if (!isNew) {
						<li class="nav-item">
							<a
								(click)="loadDriverLicense()"
								href="#drivers-license-data"
								class="nav-link p-0 custom-title custom-tab-title"
								data-bs-toggle="tab"
							>
								<div class="d-flex align-items-center justify-content-center h-100">
									{{ 'drivers.form.licenseData' | translate }}
								</div>
							</a>
						</li>
					}

					<!--<li class="nav-item">
          <a href="#view-alerts1" class="nav-link p-0 custom-title custom-tab-title" data-bs-toggle="tab">
            <div class="d-flex align-items-center justify-content-center h-100">
              Alertas
            </div>
          </a>
        </li>-->

					@if (!isNew) {
						<li class="nav-item">
							<a href="#documents1" class="nav-link p-0 custom-title custom-tab-title" data-bs-toggle="tab">
								<div class="d-flex align-items-center justify-content-center h-100">
									{{ 'drivers.form.documents' | translate }}
								</div>
							</a>
						</li>
					}

					<li class="nav-item">
						<a href="#vehicles" class="nav-link p-0 custom-title custom-tab-title" data-bs-toggle="tab">
							<div class="d-flex align-items-center justify-content-center h-100">
								{{ 'tableManagement.vehicles' | translate }}
							</div>
						</a>
					</li>

					@if (!isNew) {
						<li class="nav-item">
							<a href="#sanctions" class="nav-link p-0 custom-title custom-tab-title" data-bs-toggle="tab">
								<div class="d-flex align-items-center justify-content-center h-100">
									{{ 'tableManagement.sanction.sanction' | translate }}
								</div>
							</a>
						</li>
					}
				</ul>
			</div>
			<!-- #endregion -->

			<!-- #region ROW 2: VEHICLE INFO CARD TAB CONTENT -->
			<div class="row m-0">
				<div class="tab-content p-0">
					<!-- #region DRIVER DATA TAB  -->
					<div class="tab-pane fade show active" id="driver-data1">
						<div class="container-fluid">
							<ng-container>
								<div class="row mt-4 mb-4">
									<div class="col-sm-6">
										<label for="driver-data-field2" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'drivers.form.company' | translate }}
										</label>
										<div class="row">
											<div class="col-sm-6">
												<p-select
													[options]="billingAccountList"
													[ngModel]="entity.employee?.ceco?.billingAccount"
													i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
													dataKey="id"
													optionLabel="code"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="code"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
										<div class="row mt-2">
											<div class="col">
												<p-select
													[options]="billingAccountList"
													[ngModel]="entity.employee?.ceco?.billingAccount"
													i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
													dataKey="id"
													optionLabel="name"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="name"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
									</div>
									<!-- CECO -->
									<div class="col-sm-6">
										<label for="driver-data-field1" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'drivers.form.ceco' | translate }}
										</label>
										<div class="row">
											<div class="col-sm-6">
												<p-select
													[options]="cecoList"
													[ngModel]="entity.employee?.ceco"
													i18n-placeholder placeholder="{{'general.selectCeco' | translate}}"
													dataKey="id"
													optionLabel="code"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="code"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
										<div class="row mt-2">
											<div class="col">
												<p-select
													[options]="cecoList"
													[ngModel]="entity.employee?.ceco"
													i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
													dataKey="id"
													optionLabel="description"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="name"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
									</div>
								</div>
								<!-- #endregion -->
								<!-- #region DIVISION AND SUBDIVISION  -->
								<div class="row mt-4 mb-4">
									<!-- DIVISION -->
									<div class="col-sm-6">
										<label for="driver-data-field2" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'drivers.form.division' | translate }}
										</label>
										<div class="row">
											<div class="col-sm-6">
												<p-select
													[options]="divisionList"
													[ngModel]="entity.employee?.subdivision?.division"
													i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
													dataKey="id"
													optionLabel="code"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="code"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
										<div class="row mt-2">
											<div class="col">
												<p-select
													[options]="divisionList"
													[ngModel]="entity.employee?.subdivision?.division"
													i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
													dataKey="id"
													optionLabel="name"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="name"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
									</div>
									<!-- SUBDIVISION -->
									<div class="col-sm-6">
										<label for="driver-data-field1" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'drivers.form.subdivision' | translate }}
										</label>
										<div class="row">
											<div class="col-sm-6">
												<p-select
													[options]="subDivisionList"
													[ngModel]="entity.employee?.subdivision"
													i18n-placeholder placeholder="{{'general.selectCeco' | translate}}"
													dataKey="id"
													optionLabel="code"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="code"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
										<div class="row mt-2">
											<div class="col">
												<p-select
													[options]="subDivisionList"
													[ngModel]="entity.employee?.subdivision"
													i18n-placeholder placeholder="{{'general.selectPlaceholder' | translate}}"
													dataKey="id"
													optionLabel="name"
													[style]="{ width: '100%', 'margin-right': '5px' }"
													appendTo="body"
													filter="true"
													filterBy="name"
													[disabled]="true"
												>
												</p-select>
											</div>
										</div>
									</div>
								</div>
							</ng-container>

							<!-- #endregion  -->
							<div class="d-flex justify-content-center bd-highlight">
								<div class="p-2 bd-highlight">
									@if (!isNew) {
										<div>
											<button [disabled]="!canEdit" class="btn custom-button" (click)="saveDriver()" i18n>
												{{ 'general.save' | translate }}
											</button>
										</div>
									}
									@if (isNew) {
										<div>
											<button [disabled]="!canEdit" class="btn custom-button" (click)="saveDriver()" i18n>
												{{ 'general.create' | translate }}
											</button>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
					<!-- #endregion -->
					<!-- #region DRIVERS LICENSE DATA TAB  -->
					<div class="tab-pane fade" id="drivers-license-data">
						<div class="container-fluid">
							<!-- #region A & A2 DRIVERS LICENSE -->
							<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3 mt-4 mb-4">
								<div class="col">
									<strong
										><label for="company-data-field1" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'drivers.form.expeditionDateLicense' | translate }} (*)
										</label></strong
									>
									<input
										type="date"
										[(ngModel)]="expeditionDate"
										[disabled]="true"
										id="company-data-field1"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<strong
										><label for="company-data-field2" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'drivers.form.expirationDateLicense' | translate }} (*)
										</label></strong
									>
									<input
										type="date"
										[(ngModel)]="expirationDate"
										id="company-data-field2"
										class="form-control custom-input"
									/>
								</div>
							</div>
							<hr class="solid" />
							<!-- #region LICENSE CATEGORIES -->
							<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3 mt-4 mb-4">
								<div class="col">
									<label for="company-data-field1" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseA' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['A']"
										id="company-data-field1"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<label for="company-data-field2" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseA2' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['A2']"
										id="company-data-field2"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<label for="company-data-field3" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseB' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['B']"
										id="company-data-field3"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<label for="company-data-field4" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseC' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['C']"
										id="company-data-field4"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<label for="company-data-field5" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseC1' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['C1']"
										id="company-data-field5"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<label for="company-data-field6" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseD' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['D']"
										id="company-data-field6"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<label for="company-data-field7" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseD1' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['D1']"
										id="company-data-field7"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
								<div class="col">
									<label for="company-data-field8" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
										{{ 'drivers.form.expeditionDateLicenseCE' | translate }}
									</label>
									<input
										type="date"
										[(ngModel)]="dates['CE']"
										id="company-data-field8"
										(ngModelChange)="changeLicenseDate()"
										class="form-control custom-input"
									/>
								</div>
							</div>
							<!-- #endregion -->
							<div class="d-flex justify-content-center bd-highlight">
								<div class="p-2 bd-highlight">
									@if (!isNew) {
										<div>
											<button class="btn custom-button" (click)="saveLicenseData()" i18n>
												{{ 'drivers.form.saveLicense' | translate }}
											</button>
										</div>
									}
									@if (isNew) {
										<div>
											<button class="btn custom-button" (click)="saveLicenseData()" i18n>
												{{ 'general.create' | translate }}
											</button>
										</div>
									}
								</div>
							</div>
							<!-- #endregion -->
						</div>
					</div>
					<!-- #endregion -->
					<!-- #region SANCTIONS TAB -->
					<div class="tab-pane fade" id="sanctions">
						<div class="container-fluid p-3">
							<app-sanction-list [driver]="entity"></app-sanction-list>
						</div>
					</div>
					<!-- #endregion -->
					<!-- #region VIEW ALERTS TAB -->
					<div class="tab-pane fade" id="view-alerts1">
						<div class="container-fluid">
							<!-- #region ALERTS TABLE -->
							<div class="row mt-4 mb-4">
								<div class="col-12">
									<!--<app-vehicle-alerts-table></app-vehicle-alerts-table>-->
								</div>
							</div>
							<!-- #endregion -->
						</div>
					</div>
					<!-- #endregion -->
					<!-- #region DOCUMENTS TAB -->
					<div class="tab-pane fade" id="documents1">
						<div class="container-fluid">
							<app-doc-table [type]="type" [entity]="entity" [nested]="true"> </app-doc-table>
						</div>
					</div>
					<!-- #endregion -->
					<!-- #region VEHICLES TAB -->
					<div class="tab-pane fade" id="vehicles">
						<div class="container-fluid p-3">
							<!-- <app-vehicle-list [driver]="entity"></app-vehicle-list> -->
							<app-drivers-assignments-list [driver]="entity"></app-drivers-assignments-list>
							<!-- <ng-template ngFor let-vehicle [ngForOf]="vehicles" let-i="index">
            <label class="form-label custom-label mb-0 me-2 vehicle-label mt-3" i18n>
              {{vehicle.name}}
            </label>
          </ng-template> -->
						</div>
					</div>
					<!-- #endregion -->
				</div>
			</div>
		</div>
		</div>
		<ng-template pTemplate="footer">
			<!--<div class="d-flex flex-row-reverse bd-highlight">
				<div class="p-2 bd-highlight d-flex gap-2">
					btn historic 		
				</div>	
			</div>-->
		</ng-template>
	</p-dialog>
}
<!-- #endregion -->
